<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="open-sans-30pt">
          Varnost
        </p>
        <div style="padding-top: 20px">
          <el-tabs type="border-card" @tab-click="HandleTabClick" value="t1">
            <el-tab-pane label="Sprememba gesla" name="t1" ref="t1">
              <SpremembaGesla/>
            </el-tab-pane>
            <el-tab-pane label="Zgodovina dostopov" name="t2" ref="t2">
              <ZgodovinaDostopov/>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Tabs, TabPane} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import SpremembaGesla from './Varnost/SpremembaGesla'
import ZgodovinaDostopov from './Varnost/ZgodovinaDostopov'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'

export default {
  name: 'Varnost',
  mixins: [GetPodatkiIzbirnika],
  components: {
    'ZgodovinaDostopov': ZgodovinaDostopov,
    'SpremembaGesla': SpremembaGesla,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    }
  },
  methods: {
    HandleTabClick (tab) {
      this.activetab = tab.name
    }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/varnost.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost.vue